"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _typography = require("@berlitz/globals/lib/components/typography");
var _button = _interopRequireDefault(require("@berlitz/button"));
var _spacer = _interopRequireDefault(require("@berlitz/spacer"));
var _get = _interopRequireDefault(require("lodash/get"));
var _Testimonials = require("./Testimonials.style");
var _SocialLink = _interopRequireDefault(require("./SocialLink"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var settings = {
  dots: true,
  initialSlide: 0,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true
};
var Slide = function Slide(_ref) {
  var author = _ref.author,
    byline = _ref.byline,
    image = _ref.image,
    language = _ref.language,
    readMoreText = _ref.readMoreText,
    readMoreAsLink = _ref.readMoreAsLink,
    text = _ref.text,
    url = _ref.url,
    socialLinks = _ref.socialLinks;
  var bylineText = byline || (author && language ? "".concat(author, ", ").concat(language) : '');
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-key": "max-testimonials__slider__image"
  }, /*#__PURE__*/_react.default.createElement(_Testimonials.Container, null, /*#__PURE__*/_react.default.createElement(_Testimonials.Column, null, image && (url ? /*#__PURE__*/_react.default.createElement("a", {
    href: url,
    "aria-label": author
  }, /*#__PURE__*/_react.default.createElement(_Testimonials.Avatar, {
    image: image
  })) : /*#__PURE__*/_react.default.createElement(_Testimonials.Avatar, {
    image: image
  })), image && socialLinks && /*#__PURE__*/_react.default.createElement(_Testimonials.SocialIconsContainer, {
    "data-key": "max-testimonial__social-icons"
  }, socialLinks.map(function (_ref2) {
    var link = _ref2.link;
    return /*#__PURE__*/_react.default.createElement(_SocialLink.default, {
      key: "footer-social-".concat(link.title),
      link: link
    });
  }))), /*#__PURE__*/_react.default.createElement(_Testimonials.TextContainer, null, /*#__PURE__*/_react.default.createElement("blockquote", {
    "data-key": "max-testimonials__slider__quote"
  }, text && /*#__PURE__*/_react.default.createElement(_typography.P, {
    size: "md"
  }, text), !image && socialLinks && /*#__PURE__*/_react.default.createElement(_Testimonials.SocialIconsContainer, {
    "data-key": "max-testimonial__social-icons"
  }, socialLinks.map(function (_ref3) {
    var link = _ref3.link;
    return /*#__PURE__*/_react.default.createElement(_SocialLink.default, {
      key: "footer-social-".concat(link.title),
      link: link
    });
  })), bylineText && /*#__PURE__*/_react.default.createElement(_Testimonials.Author, null, bylineText), url && /*#__PURE__*/_react.default.createElement(_spacer.default, {
    bottom: true,
    size: "sm"
  }, readMoreAsLink ? /*#__PURE__*/_react.default.createElement(_Testimonials.Link, {
    href: url,
    to: url,
    "data-key": "max-testimonials__link"
  }, readMoreText) : /*#__PURE__*/_react.default.createElement(_button.default, {
    as: "a",
    href: url,
    outline: true,
    small: true,
    "data-key": "max-testimonials__link"
  }, readMoreText))))));
};
var Testimonials = /*#__PURE__*/function (_React$Component) {
  _inherits(Testimonials, _React$Component);
  var _super = _createSuper(Testimonials);
  function Testimonials() {
    var _temp, _this;
    _classCallCheck(this, Testimonials);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_temp = _this = _super.call.apply(_super, [this].concat(args)), _this.state = {
      didMount: false
    }, _this.componentDidMount = function () {
      return _this.setState({
        didMount: true
      });
    }, _temp));
  }
  _createClass(Testimonials, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        title = _this$props.title,
        subtitle = _this$props.subtitle,
        data = _this$props.data,
        readMoreText = _this$props.readMoreText,
        readMoreAsLink = _this$props.readMoreAsLink;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement(_Testimonials.StyledH2, {
        "data-key": "max-testimonials__heading"
      }, title), subtitle && /*#__PURE__*/_react.default.createElement(_Testimonials.Subtitle, {
        "data-key": "max-testimonials__subtitle"
      }, subtitle), this.state.didMount ? /*#__PURE__*/_react.default.createElement(_Testimonials.StyledSlider, _extends({}, settings, {
        "data-key": "max-testimonials__slider"
      }), data.map(function (testimonial) {
        return /*#__PURE__*/_react.default.createElement(Slide, {
          author: testimonial.author,
          image: testimonial.image,
          key: testimonial.text,
          language: testimonial.language,
          text: testimonial.text,
          byline: testimonial.byline,
          url: testimonial.url,
          socialLinks: testimonial.social_link,
          readMoreText: readMoreText,
          readMoreAsLink: readMoreAsLink
        });
      })) : /*#__PURE__*/_react.default.createElement(Slide, {
        author: (0, _get.default)(data, '[0].author'),
        image: (0, _get.default)(data, '[0].image'),
        key: (0, _get.default)(data, '[0].text'),
        language: (0, _get.default)(data, '[0].language'),
        text: (0, _get.default)(data, '[0].text'),
        byline: (0, _get.default)(data, '[0].byline'),
        socialLinks: (0, _get.default)(data, '[0].social_link'),
        readMoreText: readMoreText
      }));
    }
  }]);
  return Testimonials;
}(_react.default.Component);
Testimonials.defaultProps = {
  title: '',
  readMoreText: 'Read more'
};
var _default = Testimonials;
exports.default = _default;